import { render } from "./WidgetWrapper.vue?vue&type=template&id=726b865d&scoped=true"
import script from "./WidgetWrapper.vue?vue&type=script&lang=js"
export * from "./WidgetWrapper.vue?vue&type=script&lang=js"

import "./WidgetWrapper.vue?vue&type=style&index=0&id=726b865d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-726b865d"]])

export default __exports__